import { useState } from "react";
import PlusIcon from "../../../Icons/PlusIcon";
import DeleteIcon from "../../IconsCode/DeleteIcon";
import DeleteMulti from "./DeleteMulti";


const HeaderUsers = ({ selectedUsers, users, setSelectedUsers, setOpenAddUser, openError, openSuccess }) => {

    const [openDeleteMulti, setOpenDeleteMulti] = useState(false);



    return (
        <>
            <div className="flex flex-row-reverse items-center justify-between mb-8">
                {selectedUsers.length > 0 ? (
                    <div className="flex flex-row-reverse items-center">
                        <input
                            type="checkbox"
                            className="ml-2 w-4 h-4 cursor-pointer"
                            checked={selectedUsers.length === users.length}
                            onChange={(e) =>
                                setSelectedUsers(
                                    e.target.checked ? users.map((u) => u.id) : []
                                )
                            }
                        />
                        <span>انتخاب همه</span>
                        <button
                            onClick={() => setOpenDeleteMulti(true)}
                            className="flex flex-row-reverse items-center mx-8 py-2 px-8 rounded-lg bg-primary-500 text-white"
                        >
                            <DeleteIcon color="#fff" size="24" />
                            حذف
                        </button>
                    </div>
                ) : (
                    <h1 className="text-lg font-bold">لیست کاربران</h1>
                )}

                <button
                    onClick={() => setOpenAddUser(true)}
                    className="flex flex-row-reverse items-center py-2 px-8 rounded-lg bg-primary-500 text-white"
                >
                    <PlusIcon />
                    <p className="mr-2">ایجاد</p>
                </button>
            </div>

            {openDeleteMulti && (
                <DeleteMulti users={selectedUsers} close={setOpenDeleteMulti} openError={openError} openSuccess={openSuccess} />
            )}
        </>
    )
}
export default HeaderUsers;